import LogoPage from 'components/layout/LogoPage';
import Signal from 'components/loading/Signal';
import DelayRender from 'components/loading/DelayRender';
export const LoadingFallback = () => (
  <DelayRender>
    <LogoPage>
      <Signal />
      <div>
        Module laden...
        <br />
        Loading module...
      </div>
    </LogoPage>
  </DelayRender>
);

export default LoadingFallback;
